/**
 * WARNING: This file is auto-generated. Please do not modify it.
 *
 * If you need to make changes, please see the README.md file in the root of this repository.
 */

import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { Controller } from '../Controller';

import {
  GetV2ProjectsReportConfigByProjectIdParams,
  PutV2ProjectsReportConfigByProjectIdParams,
  DeleteV2ProjectsReportConfigByProjectIdParams,
  GetV2ProjectsReportConfigByProjectIdQuery,
  DeleteV2ProjectsReportConfigByProjectIdQuery,
  PutV2ProjectsReportConfigByProjectIdBody,
  GetV2ProjectsReportConfigByProjectIdResponse,
  PutV2ProjectsReportConfigByProjectIdResponse,
} from '../types';

export class ProjectReportMetricConfig extends Controller {
  async getV2ProjectsReportConfigByProjectId<
    T extends GetV2ProjectsReportConfigByProjectIdResponse,
    D,
    C
  >(
    { projectId }: GetV2ProjectsReportConfigByProjectIdParams,
    query: GetV2ProjectsReportConfigByProjectIdQuery,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      this.composeUrl(`/v2/projects/${projectId}/report-config`, query),
      axiosConfig
    );
  }

  async putV2ProjectsReportConfigByProjectId<
    T extends PutV2ProjectsReportConfigByProjectIdResponse,
    D,
    C extends PutV2ProjectsReportConfigByProjectIdBody
  >(
    body: C,
    { projectId }: PutV2ProjectsReportConfigByProjectIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.put<T, AxiosResponse<T, D>, C>(
      `/v2/projects/${projectId}/report-config`,
      body,
      axiosConfig
    );
  }

  async deleteV2ProjectsReportConfigByProjectId<T, D, C extends null>(
    { projectId }: DeleteV2ProjectsReportConfigByProjectIdParams,
    query: DeleteV2ProjectsReportConfigByProjectIdQuery,
    axiosConfig?: AxiosRequestConfig<C> | undefined,
    body?: C
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.delete<T, AxiosResponse<T, D>, C>(
      this.composeUrl(`/v2/projects/${projectId}/report-config`, query),
      { ...axiosConfig, data: body }
    );
  }
}
